
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M15.0001 5H21.0001C21.5501 5 22.0001 5.45 22.0001 6C22.0001 6.55 21.5501 7 21.0001 7H15.0001C14.4501 7 14.0001 6.55 14.0001 6C14.0001 5.45 14.4501 5 15.0001 5ZM15.0001 10.5H21.0001C21.5501 10.5 22.0001 10.95 22.0001 11.5C22.0001 12.05 21.5501 12.5 21.0001 12.5H15.0001C14.4501 12.5 14.0001 12.05 14.0001 11.5C14.0001 10.95 14.4501 10.5 15.0001 10.5ZM15.0001 16H21.0001C21.5501 16 22.0001 16.45 22.0001 17C22.0001 17.55 21.5501 18 21.0001 18H15.0001C14.4501 18 14.0001 17.55 14.0001 17C14.0001 16.45 14.4501 16 15.0001 16ZM9.85006 19.15L11.6401 17.36C11.8401 17.16 11.8401 16.85 11.6401 16.65L9.85006 14.86C9.54006 14.54 9.00006 14.76 9.00006 15.21V18.8C9.00006 19.24 9.54006 19.46 9.85006 19.15ZM9.00006 16H8.70006C6.35006 16 4.25006 14.29 4.02006 11.95C3.76006 9.27 5.87006 7 8.50006 7H11.0001C11.5501 7 12.0001 6.55 12.0001 6C12.0001 5.45 11.5501 5 11.0001 5H8.50006C4.64006 5 1.54006 8.4 2.06006 12.36C2.48006 15.64 5.43006 18 8.73006 18H9.00006' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-low-priority`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLowPriority

    ```js
    <b-new-b-icon-low-priority />
    ```
</docs>


